const closeUser = (state) => (targetUserId) => {
  const { openUsers = [] } = state;
  if (!targetUserId) return state; // bail if no new userId supplied
  if (!openUsers.some(({ userId }) => userId === targetUserId)) return state; // bail out if user not open
  return {
    ...state,
    openUsers: openUsers.filter(({ userId }) => userId !== targetUserId),
  };
};

export default closeUser;
